import React, { useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import { Row, Col, Form, Button } from "react-bootstrap";

import { formatDate } from "../../../../utils/date-utils/date-utils";

export const ServicHistorySearch = ({
  clientName,
  machineNumber,
  serviceWorksheetNo,
  salesOrderNo,
  date,
  handleSearch,
}) => {
  const intl = useIntl();

  const [clientNameValue, setClientNameValue] = useState(
    clientName ? clientName : "",
  );
  const [machineNumberValue, setMachineNumberValue] = useState(
    machineNumber ? machineNumber : "",
  );
  const [serviceWorksheetNoValue, setServiceWorksheetNoValue] = useState(
    serviceWorksheetNo ? serviceWorksheetNo : "",
  );
  const [salesOrderNoValue, setSalesOrderNoValue] = useState(
    salesOrderNo ? salesOrderNo : "",
  );
  const [dateValue, setDateValue] = useState(date ? date : "");

  const onSearch = (e) => {
    e.preventDefault();
    handleSearch({
      clientName: clientNameValue === "" ? null : clientNameValue,
      machineNumber: machineNumberValue === "" ? null : machineNumberValue,
      serviceWorksheetNo:
        serviceWorksheetNoValue === "" ? null : serviceWorksheetNoValue,
      salesOrderNo: salesOrderNoValue === "" ? null : salesOrderNoValue,
      date: dateValue === "" ? null : new Date(dateValue).getTime(),
    });
  };

  return (
    <Form onSubmit={onSearch}>
      <Row>
        <Col xs={12} md={2} className="mb-2 mb-md-0">
          <Form.Control
            type="text"
            placeholder={intl.formatMessage({
              id: "data.serviceworksheet.form.salesorder.customer",
            })}
            onChange={(e) => setClientNameValue(e.target.value)}
            value={clientNameValue}
          />
        </Col>
        <Col xs={12} md={2} className="mb-2 mb-md-0">
          <Form.Control
            type="text"
            placeholder={intl.formatMessage({
              id: "data.serviceworksheet.form.machineNumber",
            })}
            onChange={(e) => setMachineNumberValue(e.target.value)}
            value={machineNumberValue}
          />
        </Col>
        <Col xs={12} md={2} className="mb-2 mb-md-0">
          <Form.Control
            type="text"
            placeholder={intl.formatMessage({
              id: "data.serviceworksheet.form.serviceWorksheetNo",
            })}
            onChange={(e) => setServiceWorksheetNoValue(e.target.value)}
            value={serviceWorksheetNoValue}
          />
        </Col>
        <Col xs={12} md={2} className="mb-2 mb-md-0">
          <Form.Control
            type="text"
            placeholder={intl.formatMessage({
              id: "data.serviceworksheet.form.salesorder.number.placeholder",
            })}
            onChange={(e) => setSalesOrderNoValue(e.target.value)}
            value={salesOrderNoValue}
          />
        </Col>
        <Col xs={12} md={2} className="mb-2 mb-md-0">
          <Form.Control
            type="date"
            onChange={(e) => setDateValue(e.target.value)}
            value={
              dateValue ? formatDate(new Date(dateValue), "YYYY-MM-DD") : ""
            }
          />
        </Col>
        <Col xs={12} md={2} className="text-md-end">
          <Button type="submit">
            <FormattedMessage id="button.search" />
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

ServicHistorySearch.propTypes = {
  clientName: PropTypes.string,
  machineNumber: PropTypes.string,
  swerviceWorksheetNo: PropTypes.string,
  salesOrderNo: PropTypes.string,
  date: PropTypes.number,
  handleSearch: PropTypes.func.isRequired,
};
